"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serializeFilters = void 0;
// TODO use @ori/presentation-query-state not ESM only
const serializeFilters = (filters)=>filters.filter((param)=>{
        let { keys } = param;
        return keys.length > 0;
    }).map((param)=>{
        let { name, keys } = param;
        return "".concat(name, ":").concat(keys.join(','));
    }).join(';');
exports.serializeFilters = serializeFilters;
